import debounce from "../../../src/scripts/helpers/debounce";
import ScrollLinksHandler from "../../../../../Private/Fusion/Presentation/Atom/ScrollLink/ScrollLink";

export default class QuickLinks {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.quick-links'), el => {
			new QuickLinks(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.row = this.element.querySelector('.row');
		this.items = this.element.querySelectorAll('.quick-links__item');
		this.rowWidth = 0;
		this.itemsWidth = 0;

		ScrollLinksHandler.applyEventListenerOnSelector('.quick-links__item .teaser-object__link');

		window.addEventListener('load', () => {
			this.handleScrollState();

			this.row.addEventListener('scroll', () => {
				if (this.itemsWidth > this.rowWidth) {
					this.toggleArrows();
				}
			});
		});

		window.addEventListener('resize', debounce(() => {
			this.handleScrollState();
		}, 0));

		this.element.querySelector('.quick-links__navigation-button--prev').addEventListener('click', () => {
			this.row.scrollTo({
				top: 0,
				left: Math.max(0, this.row.scrollLeft - Math.max(250, this.rowWidth/3)),
				behavior: 'smooth'
			});
		});
		this.element.querySelector('.quick-links__navigation-button--next').addEventListener('click', () => {
			this.row.scrollTo({
				top: 0,
				left: this.row.scrollLeft + Math.max(250, this.rowWidth/3),
				behavior: 'smooth'
			});
		});

		let items = element.querySelectorAll('.quick-links__item');

		Array.prototype.forEach.call(items, item => {
			item.addEventListener('mouseenter', (e) => {
				e.currentTarget.classList.add('is-active');
				Array.prototype.forEach.call(this.getSiblings(e.currentTarget), el => {
					el.classList.remove('is-active');
					el.classList.add('is-inactive');
				});
			});

			item.addEventListener('mouseleave', () => {
				Array.prototype.forEach.call(items, el => {
					el.classList.remove('is-active', 'is-inactive');
				});
			});
		});
	}

	handleScrollState() {
		this.rowWidth = this.row.getBoundingClientRect().width;
		this.itemsWidth = Array.from(this.items).reduce((sum, current) => {
			return sum + current.getBoundingClientRect().width + parseFloat(window.getComputedStyle(current).marginRight) * 2;
		}, 0);

		this.element.classList[this.itemsWidth > this.rowWidth ? 'add' : 'remove']('is-scrollable');
		this.toggleArrows();
	}

	toggleArrows() {
		let gap = parseFloat(getComputedStyle(this.row).getPropertyValue('--gap-max'));
		this.element.classList[this.row.scrollLeft > (gap ? gap : 0) ? 'add' : 'remove']('is-scrollable--prev');
		this.element.classList[this.row.scrollLeft > this.row.scrollWidth - this.row.getBoundingClientRect().width - (gap ? gap : 0) ? 'remove' : 'add']('is-scrollable--next');
	}

	getSiblings = function (elem) {
		return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
			return sibling !== elem;
		});
	}
}
